import { CircleCheck as CheckCircle2, MessageCircle, ArrowRight } from 'lucide-react';
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function Hero() {
  const trustPoints = ["Fixed prices per car", "Free flight monitoring", "No hidden fees", "Pay on arrival in cash"];
  return <section id="hero" data-nav="light" className="relative overflow-hidden bg-background text-foreground isolate">
      {/* Signature Decor: Hairline with Terminal Accent */}
      <div className="pointer-events-none absolute top-0 left-0 right-0 z-10 mx-auto max-w-[1136px] px-6" aria-hidden="true">
        <div className="relative flex items-center pt-2">
          <div className="h-[1px] w-24 bg-border/60" />
          <div className="size-1.5 rounded-full bg-primary" />
        </div>
      </div>

      {/* Content Container */}
      <div className="relative z-10 mx-auto max-w-[1136px] px-6 py-12 md:py-16 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 items-center">
          {/* Left Column */}
          <div className="lg:col-span-7">
            {/* Main Headline */}
            <h1 className="font-default text-3xl font-bold tracking-tight text-black sm:text-4xl md:text-5xl lg:text-6xl leading-[1.12] text-left">
              Your Private Transfer From Hurghada Airport, Done Right
            </h1>

            {/* Supporting Text */}
            <p className="mt-6 max-w-2xl text-base text-muted-foreground sm:text-lg md:text-xl leading-relaxed text-left">
              Private, door-to-door transfers to any resort or city in Egypt with
              fixed per-vehicle pricing, licensed drivers, and door-to-door service
              included.
            </p>

            {/* Direct Action Buttons */}
            <div className="mt-8 flex flex-col items-start justify-start gap-4 sm:flex-row sm:items-center">
              <Button asChild size="lg" className="h-12 rounded-md bg-primary px-8 text-base font-medium text-primary-foreground shadow-sm hover:bg-primary/90">
                <Link to="/BookYourPrivateTransferPage">
                  Book Your Private Transfer
                  <ArrowRight className="size-4" />
                </Link>
              </Button>

              <Button asChild size="lg" className="h-12 rounded-md border-0 bg-[#27BA2A] px-8 text-base font-medium text-white shadow-sm hover:bg-[#22a025] hover:text-white">
                <Link to="https://wa.me/201010634627" newTab>
                  <MessageCircle className="size-4 text-white" />
                  Get a Quote on WhatsApp
                </Link>
              </Button>
            </div>

            {/* Trust Points */}
            <div className="mt-10 border-t border-border/60 pt-8">
              <ul className="flex flex-wrap items-center justify-start gap-x-8 gap-y-3 text-sm text-foreground/90">
                {trustPoints.map((item, index) => <li key={item} data-index={index} className="flex items-center gap-2.5">
                    <CheckCircle2 className="size-4 shrink-0 text-primary" />
                    <span>{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Right Column */}
          <div className="relative lg:col-span-5 flex justify-center lg:justify-end">
            {/* Dual brand decorative accents */}
            <div className="pointer-events-none absolute top-0 right-0 -z-10 size-40 md:size-56 rounded-full bg-primary/10 blur-3xl" aria-hidden="true" />
            <div className="pointer-events-none absolute bottom-0 left-0 -z-10 size-28 md:size-40 rounded-full bg-[var(--chart-3)]/10 blur-3xl" aria-hidden="true" />
            <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/hurghada_airport_transfer_driver.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/hurghada_airport_transfer_driver.png-wvc-sizes" alt="Driver ready for private transfer" className="w-full h-auto object-contain" src="https://devoted-mite.10web.cloud/wp-content/uploads/2026/09/Hero2.webp" />
          </div>
        </div>
      </div>
    </section>;
}